import LicenseService from '@/services/license'
import { EXPIRED_LICENSE_EXCEPTION } from "@/services/auth";
import store from '../index'
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    userLimit: null,
    userTotal: null,
    adminTotal: null,
    expirationDate: null
  },
  getters: {
    userLimit: state => state.userLimit,
    userTotal: state => state.userTotal,
    adminTotal: state => state.adminTotal,
    expirationDate: state => state.expirationDate,
    userCapacityExhausted: state => {
      if (state.userLimit === -1 || state.userLimit === null || state.userTotal === null) {
        return false
      }

      return state.userLimit < state.userTotal
    },
    expirationDateIsPassed: state => {
      const now = new Date();

      return now.getTime() > state.expirationDate.getTime()
    }
  },
  actions: {
    async loadLicense({ state, getters }) {
      if (!store.getters['auth/isAdmin']) {
        return
      }
      const license = await LicenseService.getLicense();

      if (!license) {
        return
      }

      state.userLimit = license.user_quota.limit
      state.userTotal = license.user_quota.total_user
      state.adminTotal = license.user_quota.total_admin
      state.expirationDate = new Date(license.expiration_date)

      // Check expiration date and log admin out if necessary
      if (getters.expirationDateIsPassed) {
        store.dispatch('auth/disconnectUser')
        store.dispatch('errorMessage', i18n.t('LoginPage.Error.licenseExpired'))

        throw EXPIRED_LICENSE_EXCEPTION
      }
    }
  }
}
